import { useMutation } from "react-query";
import { uploadSlide } from "../services/SlideApi";

const useCreateSlide = (id) => {
  return useMutation(uploadSlide);
};

export default useCreateSlide;
